export const CONFIG_PREVIEW_MINI = [
    {
        extension: 'jpg'
    },
    {
        extension: 'jpeg'
    },
    {
        extension: 'png'
    },
    {
        extension: 'pdf'
    },
    {
        extension: 'odp'
    },
    {
        extension: 'ods'
    },
    {
        extension: 'odt'
    },
    {
        extension: '3g2'
    },
    {
        extension: '3gp'
    },
    {
        extension: 'avi'
    },
    {
        extension: 'flac'
    },
    {
        extension: 'flv'
    },
    {
        extension: 'mkv'
    },
    {
        extension: 'mov'
    },
    {
        extension: 'mp3'
    },
    {
        extension: 'mp4'
    },
    {
        extension: 'mpg'
    },
    {
        extension: 'ogg'
    },
    {
        extension: 'ogv'
    },
    {
        extension: 'webm'
    },
    {
        extension: 'wmv'
    },
    {
        extension: 'azw'
    },
    {
        extension: 'azw3'
    },
    {
        extension: 'azw4'
    },
    {
        extension: 'epub'
    },
    {
        extension: 'fb2'
    },
    {
        extension: 'lit'
    },
    {
        extension: 'lrf'
    },
    {
        extension: 'mobi'
    },
    {
        extension: 'pdb'
    },
    {
        extension: 'bmp'
    },
    {
        extension: 'eps'
    },
    {
        extension: 'exr'
    },
    {
        extension: 'gif'
    },
    {
        extension: 'ico'
    },
    {
        extension: 'svg'
    },
    {
        extension: 'tga'
    },
    {
        extension: 'tif'
    },
    {
        extension: 'tiff'
    },
    {
        extension: 'webmp'
    },
    {
        extension: 'webp'
    }
];

export const CONFIG_PREVIEW_FILES = [
    {
        name: 'Preview Text',
        path: '/no_job_id/no_output_id/txt',
        type: 'preview_txt',
        extension: 'txt'
    },
    {
        name: 'Preview Image',
        path: '/no_job_id/no_output_id/image',
        type: 'preview_image',
        extension: 'jpg'
    },
    {
        name: 'Preview Image',
        path: '/no_job_id/no_output_id/image',
        type: 'preview_image',
        extension: 'png'
    },
];